// extracted by mini-css-extract-plugin
export default {"label":"RadioGroupField_label__AEgLY"};